import React, {Component} from 'react';
import {connect} from 'react-redux'
import bindAll from 'lodash.bindall';
import ClassDataComponent from '../components/classdata/classdata.jsx';
import {closeClassdataModal, openStudentinfoModal} from "../redux/actions/modelsActive";
import {getClassTongjiRequest, getFengchaoInfoRequest} from "../service/user";

import defaultImg from "../img/bee.png";
import PubSub from "pubsub-js";
import {dianzanStudentDuoRequest,
    getZhibiao1Request,getZhibiao2Request,getZhibiao3Request,getZhibiao1PaimingRequest,
    getZhibiao2PaimingRequest,getZhibiao3PaimingRequest} from "../service/reason";


class ClassDataContainer extends React.Component {

    constructor(props) {
        super(props)
        bindAll(this, [
            'hideAllMenu',
            'openClassValue',
            'getClassValue',
            'getClassTongjiList',
            'handleImageErrored',
            'handleImageErrored2',
            'getFengchaoInfo',
            'chakanInfo',
            'clickXueyuan',
            'clickXueke',
            'clickZhibiao2',
            'showToast',
            'clickZhibiaoTab',
            'getZhibiao1Paiming',
            'getZhibiao2Paiming',
            'getZhibiao3Paiming',
            'clickZhibiao3'
        ]);
        this.state = {
            showJuese: false,
            termInfo: [{'name': '本学期', 'code': '1'}, {'name': '本学年', 'code': '2'}, {'name': '历史累计', 'code': '3'}],
            juese_name: '本学期',
            juese_code: '1',
            studentList: [],
            studentListNew: [],
            huizhang_num: '',
            dianzan_num: '',
            class_dianzan: '',
            class_gaijin: '',
            renwen: [],
            laodong: [],
            pinde: [],
            tiyu: [],
            shuxue: [],
            yishu: [],

            isClick:false,
            xueyuanList: [],
            xueyuan_code: '',
            xueyuan_name: '',
            xuekeList: [],
            xueke_code: '',
            xueke_name: '',
            zhibiao2List: [],
            zhibiaoTab1:false,
            zhibiaoTab2:false,
            zhibiaoTab3:false,
            class_code: sessionStorage.getItem('classcode'),
            zhibiao3List: [],
            erji_code: '',
            erji_zhibiao_name: '',
            sanji_code: '',
        }

        PubSub.subscribe('faceCollectSuccess', (event, data) => {
            console.log('有新人脸采集');
            this.getClassTongjiList(this.state.juese_code);
        });

    }


    componentDidMount() {
        document.addEventListener('click', this.hideAllMenu);

        this.getClassTongjiList(this.state.juese_code);
        this.getFengchaoInfo();


        getZhibiao1Request(this.state.class_code, (data) => {
            console.log(data)
            if (data.data == '') {

            } else {
                this.setState({
                    xueyuanList: data.data.xueke,
                    // xueyuan_code: data.data.xueke[0].xueyuan_code,
                    // xuekeList: data.data.xueke[0].xueyuan_xueke
                    //xueke_code: data.data.xueke[0].xueyuan_xueke[0].xueke_code
                })
                //this.getReasonList(data.data.xueke[0].xueyuan_xueke[0].xueke_code)

            }
        })

    }

    getZhibiao1Paiming(xueke_code){
        getZhibiao1PaimingRequest(this.state.class_code, xueke_code,this.state.juese_code, (data) => {
            console.log(data)
            if (data.ret == '1') {
                var list = data.data;
                for (let i = 0; i < list.length; i++) {
                    list[i].img = list[i].img == null || list[i].img == '' ? '' : list[i].img
                }
                this.setState({
                    studentListNew: list
                });
            }else{
                this.setState({
                    studentListNew: []
                });
            }
        })
    }

    getZhibiao2Paiming(erji_code){
        getZhibiao2PaimingRequest(this.state.class_code, erji_code,this.state.juese_code, (data) => {
            console.log(data)
            if (data.ret == '1') {
                var list = data.data;
                for (let i = 0; i < list.length; i++) {
                    list[i].img = list[i].img == null || list[i].img == '' ? '' : list[i].img
                }
                this.setState({
                    studentListNew: list
                });
            }else{
                this.setState({
                    studentListNew: []
                });
            }
        })
    }

    getZhibiao3Paiming(sanji_zhibiao_code){
        getZhibiao3PaimingRequest(this.state.class_code, sanji_zhibiao_code,this.state.juese_code, (data) => {
            console.log(data)
            if (data.ret == '1') {
                var list = data.data;
                for (let i = 0; i < list.length; i++) {
                    list[i].img = list[i].img == null || list[i].img == '' ? '' : list[i].img
                }
                this.setState({
                    studentListNew: list
                });
            }else{
                this.setState({
                    studentListNew: []
                });
            }
        })
    }

    getZhibiao2List(xueke_code) {
        getZhibiao2Request( xueke_code, (data) => {
            console.log(data)

            if (data.ret == '1') {
                this.setState({
                    zhibiao2List: data.data
                })
            } else {
                this.setState({
                    zhibiao2List: [],
                    zhibiao3List: [],
                })
            }
        });
    }

    getZhibiao3List(erji_code) {
        getZhibiao3Request(erji_code, (data) => {
            console.log(data)

            if (data.ret == '1') {
                this.setState({
                    zhibiao3List: data.data

                })
            } else {
                this.setState({
                    zhibiao3List: []

                })

            }
        });
    }

    clickXueyuan(xueyuan_code, index) {
        if (xueyuan_code == this.state.xueyuan_code) {

        } else {
            //this.getZhibiao2List(this.state.xueyuanList[index].xueyuan_xueke[0].xueke_code)

            this.setState({
                zhibiao2List:[],
                zhibiao3List:[],
                xueke_code:'',
                erji_code:'',
                sanji_code:'',
                studentListNew: []

            })

        }
        this.setState({
            xueyuan_code: xueyuan_code,
            xuekeList: this.state.xueyuanList[index].xueyuan_xueke,
            //xueke_code: this.state.xueyuanList[index].xueyuan_xueke[0].xueke_code
        })
    }

    clickXueke(code, index) {
        if (code == this.state.xueke_code) {

        } else {
            // if (code == 26) {
            //     this.getZhibiao2List(code)
            // } else if (code == 27) {
            //     this.getZhibiao2List(code)
            // } else {
            //     this.getZhibiao2List(code)
            // }
            this.getZhibiao2List(code)
            this.getZhibiao1Paiming(code);

        }
        this.setState({
            xueke_code: code
        })
    }

    clickZhibiao2(erji_code) {

        this.setState({
            erji_code: erji_code
        })

        this.getZhibiao2Paiming(erji_code);
        this.getZhibiao3List(erji_code)
    }

    clickZhibiao3(sanji_code) {

        this.setState({
            sanji_code: sanji_code
        })

        this.getZhibiao3Paiming(sanji_code);
    }

    showToast(msg,duration){
        duration=isNaN(duration)?3000:duration;
        var m = document.createElement('div');
        m.innerHTML = msg;
        m.style.cssText="min-width:180px; background:#000; opacity:0.6; height:auto;min-height: 30px; color:#fff; line-height:30px; text-align:center; border-radius:4px; position:fixed; top:45%; left:50%;transform: translate(-50%,-50%);padding:15px; z-index:999999;";
        document.body.appendChild(m);
        setTimeout(function() {
            var d = 0.5;
            m.style.webkitTransition = '-webkit-transform ' + d + 's ease-in, opacity ' + d + 's ease-in';
            m.style.opacity = '0';
            setTimeout(function() { document.body.removeChild(m) }, d * 1000);
        }, duration);
    }

    hideAllMenu() {
        this.setState({
            showJuese: false
        });
    }

    chakanInfo(pid,name,face_imgurl){
        sessionStorage.setItem('studentpid',pid)
        sessionStorage.setItem('studentname',name)
        sessionStorage.setItem('face_imgurl',face_imgurl)
        this.props.openStudentinfoModal();
    }

    getClassValue(name, code) {
        if (code == this.state.juese_code) {

        } else {
            this.setState({
                juese_name: name,
                juese_code: code
            });
            if(!this.state.zhibiaoTab1&&!this.state.zhibiaoTab2&&!this.state.zhibiaoTab3){
                this.getClassTongjiList(code);
            }else{
                if(this.state.sanji_code!==''){
                    this.getZhibiao3Paiming(this.state.sanji_code)
                }else {
                    if(this.state.erji_code!==''){
                        this.getZhibiao2Paiming(this.state.erji_code)
                    }else {
                        if(this.state.xueke_code!==''){
                            this.getZhibiao1Paiming(this.state.xueke_code)
                        }else {

                        }
                    }
                }
            }

        }
        this.setState({
            showJuese: false
        })

    }

    openClassValue(e) {
        e.nativeEvent.stopImmediatePropagation();
        var show = !this.state.showJuese;
        this.setState({
            showJuese: show,
        })
    }

    handleImageErrored(index) {

        var list = this.state.studentList;
        list[index].img = defaultImg;

        this.setState({
            studentList: list,
        });

    }

    handleImageErrored2(index) {

        var list = this.state.studentListNew;
        list[index].img = defaultImg;

        this.setState({
            studentListNew: list,
        });
    }

    getClassTongjiList(juese_code) {
        getClassTongjiRequest(sessionStorage.getItem('classcode'), juese_code, (data) => {
            console.log(data)
            if (data.ret == '1') {
                var list = data.data;
                for (let i = 0; i < list.length; i++) {
                    list[i].img = list[i].img == null || list[i].img == '' ? '' : list[i].img
                }
                this.setState({
                    studentList: list
                });
            }else{
                this.setState({
                    studentList: []
                });
            }
        });
    }

    getFengchaoInfo() {
        getFengchaoInfoRequest(sessionStorage.getItem('classcode'), (data) => {
            console.log(data)
            if (data.ret == '1') {

                this.setState({
                    huizhang_num: data.data.st_hz,
                    dianzan_num: data.data.st_dz,
                    class_dianzan: data.data.class_dianzan,
                    class_gaijin: data.data.class_gaijin,
                    renwen: data.data.class_xueyuan.renwen,
                    laodong: data.data.class_xueyuan.laodong,
                    pinde: data.data.class_xueyuan.pinde,
                    tiyu: data.data.class_xueyuan.tiyu,
                    shuxue: data.data.class_xueyuan.shuxue,
                    yishu: data.data.class_xueyuan.yishu
                });
            }
        });
    }

    clickZhibiaoTab(tab){
        if(tab===1){
            var show = !this.state.zhibiaoTab1;
            this.setState({
                zhibiaoTab1:show,
            })

            this.setState({
                xueyuan_code:'',
                xuekeList:[],
                xueke_code:'',
                erji_code:'',
                sanji_code:'',
                zhibiao2List:[],
                zhibiao3List:[],
                zhibiaoTab2:false,
                zhibiaoTab3:false
            })

        }if(tab===2){
            var show = !this.state.zhibiaoTab2;
            this.setState({
                zhibiaoTab2:show
            })

            this.setState({
                erji_code:'',
                sanji_code:'',
                zhibiao3List:[],
                zhibiaoTab3:false
            })

        }if(tab===3){
            var show = !this.state.zhibiaoTab3;
            this.setState({
                zhibiaoTab3:show
            })

            if(show){
                this.setState({
                    sanji_code:'',
                    // zhibiao3List:[],
                })
                // if(this.state.erji_code!==''){
                //     this.getZhibiao3List(this.state.erji_code)
                // }

            }
        }
        // if(tab===this.state.zhibiaoTab){
        //     this.setState({
        //         zhibiaoTab:0
        //     })
        //     return;
        // }
        // if(tab===1){
        //     this.getZhibiao1Paiming(this.state.xueke_code)
        // }
        // this.setState({
        //     zhibiaoTab:tab
        // })
    }

    render() {

        return (
            <ClassDataComponent
                closeClassdataModal={this.props.closeClassdataModal}
                openClassValue={this.openClassValue}
                getClassValue={this.getClassValue}
                termInfo={this.state.termInfo}
                showJuese={this.state.showJuese}
                juese_name={this.state.juese_name}
                studentList={this.state.studentList}
                studentListNew={this.state.studentListNew}
                handleImageErrored={this.handleImageErrored}
                handleImageErrored2={this.handleImageErrored2}
                huizhang_num={this.state.huizhang_num}
                dianzan_num={this.state.dianzan_num}
                class_dianzan={this.state.class_dianzan}
                class_gaijin={this.state.class_gaijin}
                renwen={this.state.renwen}
                laodong={this.state.laodong}
                pinde={this.state.pinde}
                tiyu={this.state.tiyu}
                shuxue={this.state.shuxue}
                yishu={this.state.yishu}
                chakanInfo={this.chakanInfo}
                xueyuanList={this.state.xueyuanList}
                xueyuan_code={this.state.xueyuan_code}
                clickXueyuan={this.clickXueyuan}
                xuekeList={this.state.xuekeList}
                xueke_code={this.state.xueke_code}
                currentXueke={this.state.currentXueke}
                clickXueke={this.clickXueke}
                zhibiao2List={this.state.zhibiao2List}
                clickZhibiao2={this.clickZhibiao2}
                zhibiaoTab1={this.state.zhibiaoTab1}
                zhibiaoTab2={this.state.zhibiaoTab2}
                zhibiaoTab3={this.state.zhibiaoTab3}
                clickZhibiaoTab={this.clickZhibiaoTab}
                zhibiao3List={this.state.zhibiao3List}
                erji_code={this.state.erji_code}
                sanji_code={this.state.sanji_code}
                clickZhibiao3={this.clickZhibiao3}
            />
        )
    }


}

ClassDataContainer.propTypes = {
    // count: PropTypes.Number.isRequired,
}


const mapStateToProps = state => {
    return {
        msg: state.alert.msg,

    }
}

const mapDispatchToProps = dispatch => {
    return {
        closeClassdataModal: () => dispatch(closeClassdataModal()),
        openStudentinfoModal:() => dispatch(openStudentinfoModal()),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ClassDataContainer);
